<style lang="scss">
  @use "../../../../../assets/css/global.scss" as *;
  @use "../../../../../assets/css/_colors.scss" as *;
  #toDos {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 0.5rem;
    max-height: 90%;

    #datepickerContainer {
      display: grid;
      gap: 0.625rem;
      grid-template-columns: repeat(7, 1fr);

      .datepickerItem {
        border: 0;
        border-radius: 0.625rem;
        cursor: pointer;
        font-family: inherit;
        padding: 0.6rem 0;
        text-align: center;
        user-select: none;
        color: $text-black;

        &:hover {
          background-color: $secondary-hover-background-color;
        }
        &.selected {
          background-color: $light-blue;
          color: $blue;
        }

        &.selected {
          cursor: default;
        }

        h2 {
          color: inherit;
          line-height: 1;
          margin-top: 4px;
        }

        span {
          line-height: 1;
          @extend .text-body-2-bold;
        }
      }
    }

    #toDoInfoRow {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    #markAsDoneContainer {
      .mark-as-done-buttons {
        display: flex;
        gap: 0.5rem;
        white-space: nowrap;
        .snooze-button {
          background-color: $dark-blue;
          &:hover {
            background-color: $text-dark-blue;
          }
        }
      }

      button {
        width: 100%;
        background-color: $primary-color;
        border: 0;
        border-radius: 5rem;
        color: white;
        cursor: pointer;
        font-family: inherit;
        padding: 0.65rem;
        @extend .text-body-2-bold;
        line-height: 1;

        i {
          margin-right: 0.3rem;
        }

        &.cancel {
          background-color: $secondary-hover-background-color;
          color: $text-black;

          &:hover {
            background-color: $primary-hover-background-color;
          }
        }

        &:hover {
          background-color: $blue;
        }
      }
    }

    #overviewContainer {
      margin: 0.5rem 0rem 0.5rem auto;
      @extend .text-body-2;
      user-select: none;

      p {
        display: inline;
      }

      button {
        background: none;
        border: none;
        padding: 0;
        font: inherit;
        color: inherit;
        cursor: pointer;

        &.selected {
          span {
            font-weight: bold;
          }
        }
      }

      .noOverdue {
        font-weight: bold;
      }

      button:not(.selected) #nToDos:hover {
        color: #4e73df;
      }

      #separator {
        margin: 0 0.5rem;
      }

      #nOverdueToDos {
        color: $red;
        margin-right: 1rem;

        &.sortable {
          cursor: pointer;

          &:hover {
            p {
              color: darken($red, 10%);
            }
          }

          span {
            position: relative;

            &::before,
            &::after {
              font-size: 0.75rem;
              right: -1rem;
              position: absolute;
            }

            &::before {
              content: "\f0dd";
              font-family: "Font Awesome 6 Pro";
              font-weight: bold;
            }

            &::after {
              content: "\f0de";
              font-family: "Font Awesome 6 Pro";
              font-weight: bold;
            }
          }

          &.sortedAsc {
            span {
              &::before {
                color: darken($red, 10%);
              }
            }
          }

          &.sortedDesc {
            span {
              &::after {
                color: darken($red, 10%);
              }
            }
          }
        }
      }
    }

    .scrollArea {
      overflow-y: auto;
      padding-right: 0.5rem;
      #todoListContainer {
        max-height: 650px;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
      }
    }

    #toDosCompleteContainer {
      align-items: center;
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      gap: 1rem;
      justify-content: center;

      #textContainer {
        align-items: center;
        display: flex;
        flex-direction: column;
      }
    }

    .modal-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 1.5rem;
      text-align: center;

      h2 {
        margin-bottom: 1rem;
        color: $primary-color;
      }

      p {
        margin-bottom: 1.5rem;
        color: $text-black;
        @extend .text-body-2;
      }

      .modal-buttons {
        display: flex;
        gap: 1rem;

        button {
          padding: 0.65rem 1.5rem;
          border: 0;
          border-radius: 5rem;
          cursor: pointer;
          font-family: inherit;
          @extend .text-body-2-bold;
          line-height: 1;

          i {
            margin-right: 0.3rem;
          }

          &:first-child {
            background-color: $secondary-hover-background-color;
            color: $text-black;

            &:hover {
              background-color: $primary-hover-background-color;
            }
          }

          &:last-child {
            background-color: $primary-color;
            color: white;

            &:hover {
              background-color: $blue;
            }
          }
        }
      }
    }
  }
</style>

<script>
  import { dateForDateTimeInputValue, getTimezone, wrappedPost } from "../../../../../assets/js/src/general/utils";
import { showToast } from "@sourcewhale/core";
  import IconContainer from "../../../components/legacy/IconContainer.svelte";
  import DashboardModal from "../DashboardModals/DashboardModal.svelte";
  import {
    filteredToDos,
    filterOverdue,
    overdueSort,
    toDosByDate,
    toDosCountsByDate,
  } from "../stores";
  import {
    checkedToDos,
    completedToDoIds,
    paginatedToDos,
    preventToDoAction,
    selectedToDosActivityOptions,
    selectedToDosCampaignOptions,
    selectedToDosDate,
    toDosCampaignOptions,
    toDosTodayDate,
  } from "../utils/stores";
  import { selectedToDosUser } from "../utils/toDos";
  import { userIsOnOtherTeam } from "../utils/usersAndGroups";
  import ToDoItem from "./TodoItem.svelte";

  let showSnoozeConfirmModal = false;
  let showMarkAsDoneConfirmModal = false;

  const resetCheckedToDos = () => {
    checkedToDos.set([]);
  };

  const handleDateClick = (date) => {
    if (date !== $selectedToDosDate) {
      $filterOverdue = false;
      $overdueSort = -1;
      resetCheckedToDos();
      selectedToDosDate.set(date);
    }
  };

  const handleTotalClick = () => {
    $filterOverdue = false;
    $overdueSort = -1;
    resetCheckedToDos();
  };

  const handleOverdueClick = () => {
    if ($filterOverdue) {
      $overdueSort = -$overdueSort;
    } else {
      $filterOverdue = true;
    }
    resetCheckedToDos();
  };

  const blockToDoAction = (action) => {
    showToast({
      title: `You cannot ${action} to-do's when viewing another team`,
      type: "danger",
    });
  };

  const handleMarkAsDoneClick = () => {
    if ($userIsOnOtherTeam) {
      blockToDoAction("action");
      return;
    }
    showMarkAsDoneConfirmModal = true;
  };

  const handleSnoozeClick = () => {
    if ($userIsOnOtherTeam) {
      blockToDoAction("snooze");
      return;
    }
    showSnoozeConfirmModal = true;
  };

  const removeApproveEmails = (todos) => {
    const filtered = todos.filter(
      (todo) => todo.kind !== "sendEmailAfterInmail"
    );

    if (todos.length !== filtered.length) {
      showToast({
        title:
          "Approve Email steps can only be actioned individually. These have been omitted from your selection of done To-Dos.",
        type: "warning",
      });
    }

    return filtered;
  };

  const massMarkToDosAsDone = (todos) => {
    const processedToDos = removeApproveEmails(todos);

    if (!processedToDos.length) {
      resetCheckedToDos();
      return;
    }

    const toDoIds = processedToDos.map((todo) => todo.toDoId);
    completedToDoIds.update((ids) => [...ids, ...toDoIds]);
    resetCheckedToDos();

    wrappedPost({
      url: "/api/todos/save_status",
      data: JSON.stringify({
        toDoIds,
        status: "done",
        origin: "dashboard",
      }),
      success: () => {
        showToast({
          title: `${toDoIds.length} To-Do${toDoIds.length === 1 ? "" : "s"} marked as done`,
          type: "success",
        });
      },
    });
  };

  const handleMarkAsDoneConfirm = () => {
    showMarkAsDoneConfirmModal = false;
    massMarkToDosAsDone($checkedToDos);
  };

  const handleSnoozeConfirm = () => {
    showSnoozeConfirmModal = false;

    const toDos = $checkedToDos;

    const toDoIds = toDos.map((todo) => todo.toDoId);
    completedToDoIds.update((ids) => [...ids, ...toDoIds]);
    resetCheckedToDos();

    wrappedPost({
      url: "/api/todos/delay",
      data: JSON.stringify({
        toDoIds,
        datetime: dateForDateTimeInputValue(Date.now() / 1000 + 24 * 60 * 60),
        timezone: getTimezone(), // NOTE: this is the timezone of the VIEWER, not necessary the user whose to-dos are being snoozed
        outcomes: toDos
          .map((todo) => (todo.kind === "call" ? "callBackLater" : null))
          .filter(Boolean),
      }),
      success: () => {
        showToast({
          title: `${toDoIds.length} To-Do${toDoIds.length === 1 ? "" : "s"} snoozed for 24 hours`,
          type: "success",
        });
      },
    });
  };

  const handleUpdateNextDashboardToDos = (event) => {
    const todo = event.detail;

    const filteredToDoIdsByKind = $filteredToDos
      .filter((t) => t.kind === todo.kind)
      .map((t) => t.toDoId);

    const index = filteredToDoIdsByKind.indexOf(todo.toDoId);

    if (index === -1) {
      return;
    }

    // limit number of to-do ids stored on user object at 50
    const nextToDoIds = [
      ...filteredToDoIdsByKind.slice(index),
      ...filteredToDoIdsByKind.slice(0, index),
    ].slice(0, 50);

    if (nextToDoIds.length) {
      const data = {
        nextToDoIds,
        userId: $selectedToDosUser.value,
      };

      wrappedPost({
        url: "/api/dashboard/todos",
        data: JSON.stringify(data),
      });
    }
  };

  const calculatePaginatedToDos = (event) => {
    const todo = event.detail;

    const filteredToDosByKind = $filteredToDos.filter(
      (t) => t.kind === todo.kind
    );

    const index = filteredToDosByKind.findIndex(
      (t) => t.toDoId === todo.toDoId
    );

    if (index === -1) {
      paginatedToDos.set([]);
      return;
    }

    const nextToDos = [
      ...filteredToDosByKind.slice(index + 1),
      ...filteredToDosByKind.slice(0, index),
    ];

    paginatedToDos.set(nextToDos);
  };

  $: isSelectedDateToday = $selectedToDosDate === $toDosTodayDate;

  let totalCount = 0;
  let overdueCount = 0;
  $: {
    if ($toDosCountsByDate[$selectedToDosDate]) {
      totalCount =
        $toDosCountsByDate[$selectedToDosDate].total -
        $toDosCountsByDate[$selectedToDosDate].completed;
      overdueCount =
        $toDosCountsByDate[$toDosTodayDate].overdue -
        $toDosCountsByDate[$toDosTodayDate].completedOverdue;
    }
  }
</script>

<div id="toDos">
  <div id="datepickerContainer">
    {#each Object.entries($toDosByDate) as [date, data]}
      <button
        class="datepickerItem"
        class:selected={$selectedToDosDate === date}
        on:click={handleDateClick(date)}
      >
        <h2>{data.dateTimeInfo.day}</h2>
        <span>{data.dateTimeInfo.weekday.slice(0, 3)}</span>
      </button>
    {/each}
  </div>
  <div id="toDoInfoRow">
    {#if $checkedToDos.length}
      <div id="markAsDoneContainer">
        <div class="mark-as-done-buttons">
          <button on:click={handleMarkAsDoneClick}>
            <i class="fa-solid fa-check"></i> Mark {$checkedToDos.length} as Done
          </button>
          <button class="snooze-button" on:click={handleSnoozeClick}>
            <i class="fa-solid fa-moon"></i> Snooze for 24hrs
          </button>
          <button class="cancel" on:click={resetCheckedToDos}
            ><i class="fa-solid fa-x"></i> Cancel</button
          >
        </div>
      </div>
    {/if}
    <div id="overviewContainer">
      {#if $filteredToDos.length}
        {#if isSelectedDateToday && overdueCount}
          <button class:selected={!$filterOverdue} on:click={handleTotalClick}>
            <span id="nToDos">{totalCount} Total</span>
          </button>
          <span id="separator">|</span>
          <button
            id="nOverdueToDos"
            class="sortable"
            class:selected={$filterOverdue}
            class:sortedAsc={$filterOverdue && $overdueSort === -1}
            class:sortedDesc={$filterOverdue && $overdueSort === 1}
            on:click={handleOverdueClick}
          >
            <span>
              <p>{overdueCount} Overdue</p>
            </span></button
          >
        {:else}
          <span id="nToDos" class="noOverdue">{totalCount} Total</span>
        {/if}
      {/if}
    </div>
  </div>
  {#if $filteredToDos.length > 0}
    <div class="scrollArea">
      <div id="todoListContainer">
        {#each $filteredToDos as todo (todo.toDoId)}
          <ToDoItem
            {todo}
            ctaInactive={$preventToDoAction}
            on:update-next-dashboard-to-dos={handleUpdateNextDashboardToDos}
            on:calculate-paginated-to-dos={calculatePaginatedToDos}
          />
        {/each}
      </div>
    </div>
  {:else if $toDosCampaignOptions.length && !$selectedToDosActivityOptions.length}
    <div id="toDosCompleteContainer">
      <div id="textContainer">
        <span class="text-body-2-bold"
          >Select an outreach type from the dropdown menu to view To-Dos</span
        >
      </div>
    </div>
  {:else if $toDosCampaignOptions.length && !$selectedToDosCampaignOptions.length}
    <div id="toDosCompleteContainer">
      <div id="textContainer">
        <span class="text-body-2-bold"
          >Select a campaign from the dropdown menu to view To-Dos</span
        >
      </div>
    </div>
  {:else}
    <div id="toDosCompleteContainer">
      {#if isSelectedDateToday}
        <IconContainer icon="toDosComplete" size="xlg" />
      {/if}
      <div id="textContainer">
        <span class="text-body-2-bold"
          >{isSelectedDateToday
            ? "You're all set today!"
            : "You currently have no To-Dos on this day"}</span
        >
      </div>
    </div>
  {/if}
  {#if showSnoozeConfirmModal}
    <DashboardModal bind:showModal={showSnoozeConfirmModal} modalWidth="30rem">
      <div class="modal-content">
        <h2>Confirm Snooze</h2>
        <p>
          Are you sure you want to snooze {$checkedToDos.length}
          {$checkedToDos.length === 1 ? "To-Do" : "To-Dos"} for 24 hours?
        </p>
        <div class="modal-buttons">
          <button
            on:click={() => {
              showSnoozeConfirmModal = false;
            }}><i class="fa-solid fa-x"></i>Cancel</button
          >
          <button on:click={handleSnoozeConfirm}
            ><i class="fa-solid fa-check"></i>Confirm</button
          >
        </div>
      </div>
    </DashboardModal>
  {/if}
  {#if showMarkAsDoneConfirmModal}
    <DashboardModal
      bind:showModal={showMarkAsDoneConfirmModal}
      modalWidth="30rem"
    >
      <div class="modal-content">
        <h2>Confirm Mark as Done</h2>
        <p>
          Are you sure you want to mark {$checkedToDos.length}
          {$checkedToDos.length === 1 ? "todo" : "todos"} as done?
        </p>
        <div class="modal-buttons">
          <button
            on:click={() => {
              showMarkAsDoneConfirmModal = false;
            }}><i class="fa-solid fa-x"></i>Cancel</button
          >
          <button on:click={handleMarkAsDoneConfirm}
            ><i class="fa-solid fa-check"></i>Confirm</button
          >
        </div>
      </div>
    </DashboardModal>
  {/if}
</div>
